
export const historyEventListener = (location, action) => {
    // alert("location: " + JSON.stringify(location) + " action: " +action)
    return {
        type: "HISTORY_ACTION",
        location: location,
        action: action
    }
}


// WEBPACK FOOTER //
// ./src/common/actions/history-actions.js